import { useMutation, useQueryClient } from '@tanstack/react-query';
import getFetchWrapper from '../helpers/getFetchWrapperWithTrackingId';
import { accountSummaryV2CacheKey } from 'syf-api';
import { settlementEligibilityCheckUrl } from '../const/api-endpoints';
import { HttpMethod } from '../const/http-method';
import { useMainContext } from '../context';
import { onInvalidate } from '../helpers/enrollment';
var useSettlementEnrollment = function () {
    var _a = useMainContext(), accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config;
    var fetchWrapper = getFetchWrapper(config, accountId);
    var queryClient = useQueryClient();
    return useMutation({
        mutationKey: [settlementEligibilityCheckUrl, { accountId: accountId, accountIdType: accountIdType }],
        mutationFn: function (paymentPlan) {
            return fetchWrapper(settlementEligibilityCheckUrl, {
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: accountIdType,
                    paymentPlan: paymentPlan.planName
                }),
                method: HttpMethod.POST
            });
        },
        onSuccess: function () {
            onInvalidate({
                cacheKey: [settlementEligibilityCheckUrl, { accountId: accountId, accountIdType: accountIdType }],
                queryClient: queryClient
            });
            onInvalidate({
                cacheKey: accountSummaryV2CacheKey({ accountId: accountId, accountIdType: accountIdType }),
                queryClient: queryClient
            });
        }
    });
};
export default useSettlementEnrollment;
//# sourceMappingURL=use-settlement-enrollment.js.map